module.exports = __webpack_public_path__ + "static/img/slogan.10e5415.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer1/en/pre/slogan.png
// module id = JFl1
// module chunks = 0